<template>

    <el-form :inline="true" label-position="top">

      <el-form-item prop="powerGen" label="Produces">
        <el-input v-model="power.powerGen" placeholder="Power Kw/H" :disabled="!this.isEdit">
          <template slot="append">Kw/H</template>
        </el-input>
      </el-form-item>

      <el-form-item prop="powerGenType" label="Power Source">
        <el-select v-model="power.powerGenType"
         placeholder="Select..." :disabled="!this.isEdit">
          <el-option value="Genset">Genset</el-option>
          <el-option value="Grid Power">Grid Power</el-option>
          <el-option value="Solar">Solar</el-option>
          <el-option value="Wind">Wind</el-option>
          <el-option value="Micro-Hydro">Micro-Hydro</el-option>
        </el-select>
      </el-form-item>

    </el-form>

</template>


<script>

export default {

  props: {
    rowData: {
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      power: this.rowData
    }
  }

}
</script>
